export const consentForm = {
    gstin: '',
    gsp: '',
    username: '',
    password: '',
    pan: '',
    name: '',
    mobileNumber: '',
    emailId: '',
    validDate: null
    // gstin: '',
    // gsp: '',
    // username: '',
    // password: '',
    // pan: '',
    // name: '',
    // mobileNumber: '',
    // emailId: '',
    // validDate: null
}

export const LoginForm = {
    // mobileNumber: '8655909568',
    // reMobileNumber: '8655909568',
    // email: 'appu.response@gmail.com',
    // reEmail: 'appu.response@gmail.com',
    // pan: 'AWEPY1570B'
    mobileNumber: '',
    reMobileNumber: '',
    email: '',
    reEmail: '',
    pan: '',
}
